/**
 * Created by oswaldogallango on 7/11/16.
 */
import { CoreWebService } from './core-web.service';
import { RequestMethod } from '@angular/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { DotcmsEventsService } from './dotcms-events.service';
import { LoggerService } from './logger.service';
import { HttpCode } from './util/http-code';
/**
 * This Service get the server configuration to display in the login component
 * and execute the login and forgot password routines
 */
var LoginService = (function () {
    function LoginService(router, coreWebService, dotcmsEventsService, loggerService) {
        var _this = this;
        this.router = router;
        this.coreWebService = coreWebService;
        this.dotcmsEventsService = dotcmsEventsService;
        this.loggerService = loggerService;
        this._auth$ = new Subject();
        this._logout$ = new Subject();
        this.country = '';
        this.lang = '';
        this.nUsers = -1;
        this._loginAsUsersList$ = new Subject();
        this.urls = {
            changePassword: 'v1/changePassword',
            getAuth: 'v1/authentication/logInUser',
            loginAs: 'v1/users/loginas',
            logout: 'v1/logout',
            logoutAs: 'v1/users/logoutas',
            recoverPassword: 'v1/forgotpassword',
            serverInfo: 'v1/loginform',
            userAuth: 'v1/authentication'
        };
        // when the session is expired/destroyed
        dotcmsEventsService.subscribeTo('SESSION_DESTROYED').pluck('data').subscribe(function (date) {
            _this.loggerService.debug('Processing session destroyed: ', date);
            _this.loggerService.debug('User Logged In Date: ', _this.auth.user.loggedInDate);
            // if the destroyed event happens after the logged in date, so proceed!
            if (_this.isLogoutAfterLastLogin(date)) {
                _this.logOutUser().subscribe(function () { });
            }
        });
    }
    Object.defineProperty(LoginService.prototype, "loginAsUsersList$", {
        get: function () {
            return this._loginAsUsersList$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoginService.prototype, "auth$", {
        get: function () {
            return this._auth$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoginService.prototype, "logout$", {
        get: function () {
            return this._logout$.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoginService.prototype, "auth", {
        get: function () {
            return this._auth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LoginService.prototype, "isLogin$", {
        get: function () {
            var _this = this;
            return Observable.if(function () { return !!_this.auth && !!_this.auth.user; }, Observable.of(true), this.loadAuth().map(function (auth) { return !!auth && !!auth.user; }));
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Load _auth information.
     * @returns {Observable<any>}
     */
    LoginService.prototype.loadAuth = function () {
        var _this = this;
        return this.coreWebService
            .requestView({
            method: RequestMethod.Get,
            url: this.urls.getAuth
        })
            .pluck('entity')
            .do(function (auth) {
            if (auth.user) {
                _this.setAuth(auth);
            }
        })
            .map(function (auth) { return auth; });
    };
    /**
     * Change password
     * @param password
     * @param token
     * @returns {Observable<any>}
     */
    LoginService.prototype.changePassword = function (password, token) {
        var body = JSON.stringify({ password: password, token: token });
        return this.coreWebService.requestView({
            body: body,
            method: RequestMethod.Post,
            url: this.urls.changePassword
        });
    };
    /**
     * Get the server information to configure the login component
     * @param language language and country to get the internationalized messages
     * @param i18nKeys array of message key to internationalize
     * @returns {Observable<any>} Observable with an array of internationalized messages and server configuration info
     */
    LoginService.prototype.getLoginFormInfo = function (language, i18nKeys) {
        this.setLanguage(language);
        return this.coreWebService.requestView({
            body: { messagesKey: i18nKeys, language: this.lang, country: this.country },
            method: RequestMethod.Post,
            url: this.urls.serverInfo
        });
    };
    /**
     * Do the login as request and return an Observable.
     * @param user user to loginas
     * @param password loginin user's password
     * @returns {Observable<R>}
     */
    // TODO: password in the url is a no-no, fix asap. Sanchez and Jose have an idea.
    LoginService.prototype.loginAs = function (userData) {
        var _this = this;
        return this.coreWebService
            .requestView({
            body: {
                password: userData.password,
                userId: userData.user.userId
            },
            method: RequestMethod.Post,
            url: this.urls.loginAs
        })
            .map(function (res) {
            if (!res.entity.loginAs) {
                throw res.errorsMessages;
            }
            _this.setAuth({
                loginAsUser: userData.user,
                user: _this._auth.user,
                isLoginAs: true
            });
            return res;
        })
            .pluck('entity', 'loginAs');
    };
    /**
     * Executes the call to the login rest api
     * @param login User email or user id
     * @param password User password
     * @param rememberMe boolean indicating if the _auth want to use or not the remenber me option
     * @param language string with the language and country code, ex: en_US
     * @returns an array with the user if the user logged in successfully or the error message
     */
    LoginService.prototype.loginUser = function (login, password, rememberMe, language) {
        var _this = this;
        this.setLanguage(language);
        return this.coreWebService
            .requestView({
            body: {
                userId: login,
                password: password,
                rememberMe: rememberMe,
                language: this.lang,
                country: this.country
            },
            method: RequestMethod.Post,
            url: this.urls.userAuth
        })
            .map(function (response) {
            var auth = {
                loginAsUser: null,
                user: response.entity,
                isLoginAs: false
            };
            _this.setAuth(auth);
            _this.coreWebService
                .subscribeTo(HttpCode.UNAUTHORIZED)
                .subscribe(function () { return _this.logOutUser().subscribe(function () { }); });
            return response.entity;
        });
    };
    /**
     * Logout "login as" user
     * @returns {Observable<R>}
     */
    LoginService.prototype.logoutAs = function () {
        var _this = this;
        return this.coreWebService
            .requestView({
            method: RequestMethod.Put,
            url: "" + this.urls.logoutAs
        })
            .map(function (res) {
            _this.setAuth({
                loginAsUser: null,
                user: _this._auth.user,
                isLoginAs: true
            });
            return res;
        });
    };
    /**
     * Call the logout rest api
     * @returns {Observable<any>}
     */
    LoginService.prototype.logOutUser = function () {
        var _this = this;
        return this.coreWebService
            .requestView({
            method: RequestMethod.Get,
            url: this.urls.logout
        })
            .map(function (response) {
            var nullAuth = {
                loginAsUser: null,
                user: null,
                isLoginAs: false
            };
            _this.loggerService.debug('Processing the logOutUser');
            _this.setAuth(nullAuth);
            // on logout close the websocket
            _this.dotcmsEventsService.destroy();
            _this.loggerService.debug('Navigating to Public Login');
            _this.router.navigate(['/public/login']);
        });
    };
    /**
     * Executes the call to the recover passwrod rest api
     * @param email User email address
     * @returns an array with message indicating if the recover password was successfull
     * or if there is an error
     */
    LoginService.prototype.recoverPassword = function (login) {
        return this.coreWebService.requestView({
            body: { userId: login },
            method: RequestMethod.Post,
            url: this.urls.recoverPassword
        });
    };
    /**
     * Subscribe to ser change and call received function on change.
     * @param func function will call when user change
     */
    LoginService.prototype.watchUser = function (func) {
        if (this.auth) {
            func(this.auth);
        }
        this.auth$.subscribe(function (auth) {
            if (auth.user) {
                func(auth);
            }
        });
    };
    /**
     * Set logged_auth and update auth Observable
     * @param _auth
     */
    LoginService.prototype.setAuth = function (auth) {
        this._auth = auth;
        this._auth$.next(auth);
        // When not logged user we need to fire the observable chain
        if (!auth.user) {
            this._logout$.next();
        }
        else {
            this.dotcmsEventsService.start();
        }
    };
    LoginService.prototype.isLogoutAfterLastLogin = function (date) {
        return (this.auth.user &&
            this.auth.user.loggedInDate &&
            date &&
            Number(date) > Number(this.auth.user.loggedInDate));
    };
    /**
     * update the language and country variables from the string
     * @param language string containing the language and country
     */
    LoginService.prototype.setLanguage = function (language) {
        if (language !== undefined && language !== '') {
            var languageDesc = language.split('_');
            this.lang = languageDesc[0];
            this.country = languageDesc[1];
        }
        else {
            this.lang = '';
            this.country = '';
        }
    };
    /**
     * Request and store the login as _auth list.
     */
    LoginService.prototype.loadLoginAsUsersList = function (includeNUsers, filter) {
        return this.coreWebService
            .requestView({
            method: RequestMethod.Get,
            url: this.urls
                .loginAsUserList + "?includeUsersCount=" + includeNUsers + "&filter=" + filter
        })
            .pluck('entity');
    };
    return LoginService;
}());
export { LoginService };
LoginService.decorators = [
    { type: Injectable },
];
/** @nocollapse */
LoginService.ctorParameters = function () { return [
    { type: Router, },
    { type: CoreWebService, },
    { type: DotcmsEventsService, },
    { type: LoggerService, },
]; };
//# sourceMappingURL=login.service.js.map